module.exports = __webpack_public_path__ + "img/logo.14cff3c1.jpg";